import { signal } from '@preact/signals';

export const toast = signal<string | null>(null);
let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function showToast(message: string, ms = 2400): void {
  clearTimeout(toastTimer);
  toast.value = message;
  toastTimer = setTimeout(() => (toast.value = null), ms);
}

/** Which bottom sheet is open, and what it starts with. */
export type SheetSpec =
  | { kind: 'sale'; partyId?: string }
  | { kind: 'purchase'; partyId?: string }
  | { kind: 'item'; id?: string }
  | { kind: 'party'; id?: string; type?: 'customer' | 'vendor' }
  | { kind: 'payment'; direction: 'in' | 'out'; partyId?: string; amount?: number }
  | { kind: 'return'; itemId?: string }
  | { kind: 'expense' }
  | { kind: 'drawing' }
  | { kind: 'transfer' }
  | { kind: 'account'; id?: string }
  | { kind: 'user'; id?: string }
  | { kind: 'adjust'; itemId: string; bin?: 'stock' | 'defective' }
  | { kind: 'entry'; id: string };

export const sheet = signal<SheetSpec | null>(null);

export function openSheet(spec: SheetSpec): void {
  sheet.value = spec;
}

export function closeSheet(): void {
  sheet.value = null;
}

export const wide = signal(typeof window !== 'undefined' ? window.innerWidth >= 820 : true);
if (typeof window !== 'undefined') {
  window.addEventListener('resize', () => (wide.value = window.innerWidth >= 820));
}

/** Whether lists also show voided entries (struck through). Remembered per device. */
const VOIDED_KEY = 'khata.showVoided';
function initialShowVoided(): boolean {
  try {
    return localStorage.getItem(VOIDED_KEY) === '1';
  } catch {
    return false;
  }
}
export const showVoided = signal(initialShowVoided());
export function setShowVoided(on: boolean): void {
  showVoided.value = on;
  try {
    localStorage.setItem(VOIDED_KEY, on ? '1' : '0');
  } catch {
    // no storage
  }
}

/** Which period the entry lists show. Shared by all lists so the choice sticks while moving around. */
export type ListPeriod =
  { kind: 'this' } | { kind: 'last' } | { kind: 'all' } | { kind: 'month'; month: string };
export const listPeriod = signal<ListPeriod>({ kind: 'this' });
